module.exports = __webpack_public_path__ + "nunito-sans-latin-400italic.e14ffefb3a60e5d5a9a47519882f92e8.woff";